// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const CscConfig = t.struct({
    callingApplicationId: t.String,
    csc2Url: t.String,
    cscUrl: t.String,
    cssFileToUse: t.String,
    returnUrl: t.String,
    sourceProgram: t.String
}, {
    name: 'CscConfig',
    strict: true
});

export const getDefaultState = () => new CscConfig({
    callingApplicationId: '',
    csc2Url: '',
    cscUrl: '',
    cssFileToUse: '',
    returnUrl: '',
    sourceProgram: ''
});

export default CscConfig;



// WEBPACK FOOTER //
// ./src/shared/models/csc-config.js